export const resellerPageTitles = {
  "/reseller/dashboard": "Dashboard",
  "/reseller/orders": "Orders",
  "/reseller/viewProduct": "View Products",
  "/reseller/ResellProduct/:id": "Add Product for Resell",
  "/reseller/wallet": "Wallet",
  "/reseller/MyProduct": "My Products",
  "/reseller/profile": "My Profile",
  "/reseller/editProfile": "Edit Profile",
  "/reseller/GetReWithdrowRequest": "Get Withdraw Requests",
};
